import { InputDate } from '../../form/InputDate';
import { Bubble, Props } from './Bubble';
import './inputDateBubble.scss';
import dayjs from 'dayjs';
import { useState } from 'react';
import { CalendarPinkIcon, CalendarDefaultIcon } from '@raysee/icon';

const DEFAULT_DATE = new Date(2000, 0, 1);

export const InputDateBubble = (props: Props) => {
  const [date, setDate] = useState(DEFAULT_DATE);
  const [isOpen, setIsOpne] = useState(false);
  const [isDefault, setIsDefault] = useState(true);

  const onSelect = () => {
    if (!isDefault) setIsOpne(false);
    props.onSend(dayjs(date).format('YYYY/MM/DD'));
  };

  const onCancel = () => {
    setDate(DEFAULT_DATE);
    setIsOpne(false);
    setIsDefault(true);
  };

  const onChange = (date: Date) => {
    setDate(date);
    setIsDefault(false);
  };

  return (
    <>
      <Bubble {...props}>
        <div className="rounded-2xl border bg-white px-4 py-3 drop-shadow-sm">
          <p>{props.message.text}</p>
        </div>
      </Bubble>
      {props.isWaiting && <div className="h-24"></div>}
      {props.isWaiting && (
        <div className="fixed bottom-0 flex w-full max-w-[480px] flex-wrap justify-center bg-white p-2">
          {props.message.optional && (
            <button
              className="mx-2 my-2 flex-grow rounded-md border border-[#ff66c4]  py-2 text-sm font-bold text-[#ff66c4]"
              onClick={() => props.onSend('分からない')}
            >
              わからない
            </button>
          )}
          <button
            className={`mx-2 my-2 flex-grow rounded-md  border border-[#ff66c4] py-2 ${
              props.message.optional && 'bg-brand'
            }`}
            onClick={() => setIsOpne(true)}
          >
            <div className="flex items-center justify-center">
              {props.message.optional ? <CalendarPinkIcon /> : <CalendarDefaultIcon />}
              <span
                className={`mx-2 font-semibold text-[#ff66c4] ${
                  props.message.optional && 'text-white'
                }`}
              >
                {isDefault ? '生年月日を入力' : dayjs(date).format('YYYY/M/D')}
              </span>
            </div>
          </button>
          <div className={`bottom-0 w-full max-w-[480px]`}>
            <InputDate
              date={date}
              isDefault={isDefault}
              isOpen={isOpen}
              onSelect={onSelect}
              onCancel={onCancel}
              onChange={onChange}
            />
          </div>
        </div>
      )}
    </>
  );
};
